export default {
    // --------Title--------
    information: '信息',
    profileDataDetails: '档案资料详情',
    scopes: '范围',
    groupingDataRange: '分组数据范围',
    
    // --------MUI--------
    actionType: '操作类型',
    owners: '拥有者',
    users: '用户',

};